import React, {Component} from "react";
import {TextDisplayProperties} from '../../content/displayproperties/TextDisplayProperties';
import {ThemeProvider, Typography} from '@mui/material';

export default class TextCell extends Component<TextDisplayProperties> {
    override render() {
        return<ThemeProvider theme={{}}>
            <Typography
                fontSize={"18px"}
                color={this.props.color}
                fontWeight={this.props.bold ? 'bold' : 'medium'}>
                {this.props.content}
            </Typography>
        </ThemeProvider>
    }
}
